module.exports = __webpack_public_path__ + "static/media/7.e88e9a45.svg";